// import { useTranslation } from 'react-i18next';
// import { Card, CardBody, CardHeader } from '@components/card/card';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetPurchaseRequestList from '@hooks/PUR/PurchaseRequest/useGetPurchaseRequestList';
// import NtxTable from '@components/DataTable/NtxTable';

// interface Props {
//   Route: 'Quotation' | 'PurchaseOrder' | 'ApInvoice';
// }

// const PurchaseRequestList = ({ Route }: Props) => {
//   const { t, i18n } = useTranslation();
 
//   const { PurchaseRequestsList, loading, error } = useGetPurchaseRequestList();

//   const columns = [
//     { title: t('Number'), key: 'code' },
//     { title: t('Date'), key: 'date' },
//     // { title: t('Customer'), key: 'customer' },
//     { title: t('Branch'), key: 'branch' },
//     { title: t('الوصف'), key: 'description' },
//     { title: t(''), key: 'action', className: 'text-end' },
//   ];

//   const tableData = PurchaseRequestsList?.slice()
//     ?.sort((a, b) => b?.no - a?.no)
//     ?.map((item) => {
//       let rowClass;

//       return {
//         code: item.code,
//         date: item.transactionDate?.toString().split('T')[0],
//         branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//         description: i18n.language === 'en' ? item.description : item.description,
//         action: (
//           <>
//             <Link
//               className="btn btn-sm btn-theme"
//               to={
//                 Route === 'PurchaseOrder'
//                   ? `/PUR/PurchaseOrder/AddPurchaseOrder/not_multi/${item.id}`
//                   : Route === 'Quotation'
//                   ? `/PUR/Quotation/AddPurchaseQuotation/${item.id}`
//                   : Route === 'ApInvoice'
//                   ? `/Finance/Ap/ApInvoices/AddApInvoices/${item.id}`
//                   : ''
//               }>
//               <i className="bi bi-cart-plus me-2 "></i>
//               {t('إنــشاء')}
//             </Link>
//           </>
//         ),

//         rowClass,
//       };
//     });

//   return (
//     <Card>
//       <Loading loading={loading} error={error} Type="Dots">
//         <CardHeader className="d-flex justify-content-between align-items-center ">
//           <h5 className="m-0">{t('طلبــات الشـراء')}</h5>
//         </CardHeader>

//         <CardBody>
//           <NtxTable
//             data={tableData || []}
//             columns={columns}
//             dataPerPage={8}
//             theadClass=""
//             tableClass="table text-nowrap table-hover "
//             enableSearch
//             // showRecordsSelector
//           />
//         </CardBody>
//       </Loading>
//     </Card>
//   );
// };

// export default PurchaseRequestList;

import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

interface Props {
  Route: 'Quotation' | 'PurchaseOrder' | 'ApInvoice';
}

const PurchaseRequestList = ({ Route }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // ✅ TableKey خاص بالمودال حتى لا يتعارض مع شاشة PurchaseRequests_Index
  const TABLE_KEY = useMemo(() => `PurchaseRequestListModal_${Route}`, [Route]);

  const [searchFilter, setSearchFilter] = useState('');

  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'PurchaseRequest/GetList_paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch, TABLE_KEY]);

  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const applySearch = () => {
    const newFilters: any[] = [];

    if (searchFilter?.trim()) {
      newFilters.push({
        id: generateFilterId(),
        field: 'code',
        operator: 7, // OpContains
        value: searchFilter.trim()
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const clearSearch = () => {
    setSearchFilter('');
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const getCreateLink = (id: string) => {
    if (Route === 'PurchaseOrder') return `/PUR/PurchaseOrder/AddPurchaseOrder/not_multi/${id}`;
    if (Route === 'Quotation') return `/PUR/Quotation/AddPurchaseQuotation/${id}`;
    if (Route === 'ApInvoice') return `/Finance/Ap/ApInvoices/AddApInvoices/${id}`;
    return '';
  };

  const displayData = data;

  return (
    <Card>
      <Loading loading={loading} error={error} Type='Dots'>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='m-0'>{t('طلبــات الشـراء')}</h5>

          <div className='d-flex gap-2 align-items-center'>
            <div className='input-group' style={{ width: 320 }}>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-search'></i>
              </span>
              <input
                className='form-control'
                value={searchFilter}
                onChange={e => setSearchFilter(e.target.value)}
                placeholder={t('بحث برقم الطلب (PR...)')}
              />
            </div>

            <button
              type='button'
              className='btn btn-theme'
              onClick={applySearch}
              disabled={!searchFilter?.trim()}
              title={t('ApplyFilters')}
            >
              <i className='fas fa-filter fa-fw me-1'></i>
              {t('بحث')}
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={clearSearch}
              disabled={!filters?.length}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
          </div>
        </CardHeader>

        <CardBody className='p-0'>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>{t('Number')}</th>
                  <th className='small'>{t('Date')}</th>
                  <th className='small'>{t('Branch')}</th>
                  <th className='small'>{t('الوصف')}</th>
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>

              <tbody>
                {displayData?.length > 0 ? (
                  displayData.map((item: any) => (
                    <tr key={item.id}>
                      <td className='align-middle'>
                        <strong className='text-theme'>{item.code}</strong>
                      </td>

                      <td className='align-middle'>{String(item.transactionDate || '').split('T')[0]}</td>

                      <td className='align-middle'>
                        {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                      </td>

                      <td className='align-middle'>
                        <span className='text-muted'>{item.description || '-'}</span>
                      </td>

                      <td className='align-middle text-end'>
                        <Link className='btn btn-sm btn-theme' to={getCreateLink(item.id)}>
                          <i className='bi bi-cart-plus me-2'></i>
                          {t('إنــشاء')}
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {filters?.length ? t('NoSearchResults') : t('NoPurchaseRequests')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardBody>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Loading>
    </Card>
  );
};

export default PurchaseRequestList;

